var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAutomFlow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "#1E1E1E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Autom Store",
    clipPath: "url(#clip0_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 868,
    transform: "translate(-472 -368)",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 112",
    x: -472,
    y: -368,
    width: 1440,
    height: 962,
    fill: "#C4C4C4",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 226",
    x: -175.5,
    y: -301.5,
    width: 1111,
    height: 733,
    rx: 4.5,
    fill: "white",
    stroke: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 1879"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1217"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 437",
    x: -148.75,
    y: -27.75,
    width: 1056.5,
    height: 75.5,
    rx: 4.75,
    fill: "white",
    stroke: "#CFCFCF",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Component 8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 808",
    filter: "url(#filter0_d_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -12,
    y: -13,
    width: 45,
    height: 45,
    rx: 4,
    fill: "#4F6E90"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 665"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.3459 1.57056L9.65199 4.26445M9.65199 4.26445L12.3459 6.95834M9.65199 4.26445H13.6928C15.9245 4.26445 17.7337 6.0736 17.7337 8.30529V10.9992M4.26421 15.04C2.77641 15.04 1.57031 16.2461 1.57031 17.7339C1.57031 19.2217 2.77641 20.4278 4.26421 20.4278C5.752 20.4278 6.9581 19.2217 6.9581 17.7339C6.9581 16.2461 5.752 15.04 4.26421 15.04ZM4.26421 15.04V6.95834M4.26421 6.95834C5.752 6.95834 6.9581 5.75225 6.9581 4.26445C6.9581 2.77665 5.752 1.57056 4.26421 1.57056C2.77641 1.57056 1.57031 2.77665 1.57031 4.26445C1.57031 5.75225 2.77641 6.95834 4.26421 6.95834ZM17.7337 10.9992C16.2459 10.9992 15.0398 12.2053 15.0398 13.6931C15.0398 15.1809 16.2459 16.387 17.7337 16.387C19.2215 16.387 20.4276 15.1809 20.4276 13.6931C20.4276 12.2053 19.2215 10.9992 17.7337 10.9992Z",
    stroke: "white",
    strokeWidth: 1.83334
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group 1896"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1217_2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 437_2",
    x: -148.75,
    y: -27.75,
    width: 1056.5,
    height: 75.5,
    rx: 4.75,
    fill: "white",
    stroke: "#CFCFCF",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Component 8_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 808_2",
    filter: "url(#filter1_d_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -12,
    y: -13,
    width: 45,
    height: 45,
    rx: 4,
    fill: "#4F6E90"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 665_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.3459 1.57056L9.65199 4.26445M9.65199 4.26445L12.3459 6.95834M9.65199 4.26445H13.6928C15.9245 4.26445 17.7337 6.0736 17.7337 8.30529V10.9992M4.26421 15.04C2.77641 15.04 1.57031 16.2461 1.57031 17.7339C1.57031 19.2217 2.77641 20.4278 4.26421 20.4278C5.752 20.4278 6.9581 19.2217 6.9581 17.7339C6.9581 16.2461 5.752 15.04 4.26421 15.04ZM4.26421 15.04V6.95834M4.26421 6.95834C5.752 6.95834 6.9581 5.75225 6.9581 4.26445C6.9581 2.77665 5.752 1.57056 4.26421 1.57056C2.77641 1.57056 1.57031 2.77665 1.57031 4.26445C1.57031 5.75225 2.77641 6.95834 4.26421 6.95834ZM17.7337 10.9992C16.2459 10.9992 15.0398 12.2053 15.0398 13.6931C15.0398 15.1809 16.2459 16.387 17.7337 16.387C19.2215 16.387 20.4276 15.1809 20.4276 13.6931C20.4276 12.2053 19.2215 10.9992 17.7337 10.9992Z",
    stroke: "white",
    strokeWidth: 1.83334
  }))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_0_1",
    x: -16,
    y: -17,
    width: 53,
    height: 53,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_1",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_0_1",
    x: -16,
    y: -17,
    width: 53,
    height: 53,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_1",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 868,
    fill: "white",
    transform: "translate(-472 -368)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutomFlow);
export default __webpack_public_path__ + "static/media/autom-flow.fb9711d97cf7ae482d1d6f9a06348c48.svg";
export { ForwardRef as ReactComponent };